import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AGUIconName } from '../icon/icon-paths';

/** Amber is the lapsed-membership strip (P/proto-states.js:134); error is a partial or save failure (:111, :123). */
export type AGUStateBannerTone = 'amber' | 'error';

/**
 * The product-state strip, `.ps-banner` (P/proto-states.js:50, 155-158): an 18 px glyph, the sentence, one button. Error banners
 * carry the quiet `.q` button (:111, :123); the amber one the solid amber button (:134, :157). Content projected into the banner
 * follows `Text` inside the sentence, for a bold run such as "<b>Jobs could not refresh</b>." (:111); the retry note after a
 * second failure lands inside the sentence too, as the prototype appends it to `.t` (:237).
 */
@Component({
    standalone: false,
    selector: 'agu-state-banner',
    templateUrl: './state-banner.component.html',
    styleUrl: './state-banner.component.scss',
})
export class AGUStateBannerComponent {
    @Input() Tone: AGUStateBannerTone = 'error';
    @Input() Text = '';
    @Input() ActionLabel: string | null = null;
    /** The retry note after a second failure (P/proto-states.js:234-237). */
    @Input() Note: string | null = null;

    @Output() readonly Action = new EventEmitter<void>();

    /** The strip's glyph: alert for an error, the clock for the lapsed strip (P/proto-states.js:111, 134). */
    get Glyph(): AGUIconName {
        return this.Tone === 'amber' ? 'clock' : 'alert';
    }

    OnAction(): void {
        this.Action.emit();
    }
}
